import AxiosConfig from '@/config/axios-config'
/* Remover esse defaultParams das chamadas quando a passagem do empresaId estiver funcionando pelo axios-config.js */
const defaultParams = {
  params: {
    empresaId: process.env.VUE_APP_EMPRESA_REF
  }
}

export const NotificacaoAPI = {

  obterNotificacao: function (id, pagina) {
    if (id) {
      return AxiosConfig.secureJalekoAPI().get(`/notificacoes/${id}`,
        { params: { page: pagina } }).then(response => response.data)
    }
    return AxiosConfig.secureJalekoAPI().get(`/notificacoes?page=${pagina}`, defaultParams).then(response => response.data)
  },

  obterNotificacaoPorTipo: function (id, pagina) {
    return AxiosConfig.secureJalekoAPI().get(`/notificacoes/tipo/${id}`, defaultParams).then(response => response.data)
  },

  obterTiposDeNotificacao: function () {
    return AxiosConfig.secureJalekoAPI().get(`/notificacoes-tipos`, {}, defaultParams).then(response => response.data)
  },

  registrarVisualizacao: function (notificacoesIds) {
    if (notificacoesIds) { // Ultimas notificacoes
      return AxiosConfig.secureJalekoAPI().put(`/notificacoes`,
        {
          'ultimas_notificacoes': notificacoesIds
        },
        defaultParams).then(response => response.data)
    }
    // Todas as notificacoes
    return AxiosConfig.secureJalekoAPI().put(`/notificacoes`, {}, defaultParams).then(response => response.data)
  },

  registrarAcesso: function (id) {
    return AxiosConfig.secureJalekoAPI().put(`/notificacoes/${id}`).then(response => response.data)
  }

}

export default NotificacaoAPI
